module.exports = __webpack_public_path__ + "img/1518483182.717da1ab.jpg";